// Vendor scripts
import 'bootstrap'

// Vue
import './vue/vue.js'

// Gogo
import './scripts/helpers.js'
import './scripts/form-contact.js'

// Custom scripts
window.initMap = require('./scripts/map').default;
import './scripts/accordion-search'
import './scripts/alert'
import './scripts/anchor'
import './scripts/collapse-prevent-close'
import './scripts/header'
import './scripts/image-caption-toggle'
import './scripts/image-modal'
import './scripts/modal-links'
import './scripts/pdf-modal'
import './scripts/swiper-config'
import './scripts/slim-select-config'
import './scripts/video-modal'
import './scripts/aos-config'
import './scripts/upcoming-events'
